import { useAuthStore } from "../../../../../../store/hooks";

export const useNavBarViewModel = () => {
  const authStore = useAuthStore();

  return {
    roleTitle: authStore.roleTitle,
  };
};
